import { useNavigate } from 'react-router-dom';
import { animeList } from '@/mocks/anime';

export default function FeaturedAnime() {
  const navigate = useNavigate();
  const hotAnime = animeList.filter((a) => a.isHot);

  const handleClick = (id: string) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    navigate(`/article/${id}`);
  };

  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">大家都在追的精彩番剧</p>
          </div>
          <button
            onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' }); navigate('/category/all'); }}
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotAnime.map((anime) => (
            <div
              key={anime.id}
              onClick={() => handleClick(anime.id)}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200 mb-3">
                <img
                  src={anime.coverImage}
                  alt={anime.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <div className="w-full flex items-center justify-between">
                    <span className="text-white text-xs font-medium bg-primary-500 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {anime.rating}分
                    </span>
                    <span className="text-white/80 text-xs whitespace-nowrap">
                      {anime.episodes}集
                    </span>
                  </div>
                </div>
                {anime.isNew && (
                  <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
                    新番
                  </span>
                )}
                <span className="absolute top-2 right-2 bg-black/60 text-white text-xs px-2 py-0.5 rounded-full whitespace-nowrap">
                  {anime.status}
                </span>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                {anime.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">
                {anime.category} · {anime.subCategory} · {anime.year}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}